<ng-container [ngTemplateOutlet]="route !== undefined ? withRoute : withoutRoute"></ng-container>

<ng-template #withRoute>
  @if (disabled === false) {
    <portal-link
      [className]="buttonClass"
      [params]="routeParams"
      [returnTo]="returnTo"
      [returnToLabel]="returnToLabel"
      [returnToParams]="returnToParams"
      [route]="route"
    >
      <i [ngClass]="iconClass"></i>
    </portal-link>
  } @else {
    <button [ngClass]="buttonClassName" disabled><i [ngClass]="iconClass"></i></button>
  }
</ng-template>

<ng-template #withoutRoute>
  <button
    [disabled]="loading || disabled"
    [ngClass]="buttonClassName"
    [tabindex]="tabindex"
    (click)="emitClick($event)"
    type="button"
  >
    @if (!loading) {
      <i [ngClass]="iconClass"></i>
    }

    @if (loading) {
      <i class="far fa-circle-notch fa-spin"></i>
    }

    @if (showProgress === true && loading === false) {
      <svg
        class="portal-radial-indicator"
        id="svg"
        @fadeInOut
        [attr.height]="radius * 2"
        [attr.viewPort]="'0 0 ' + radius * 2 + ' ' + radius * 2"
        [attr.width]="radius * 2"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          id="bar"
          [attr.cx]="radius"
          [attr.cy]="radius"
          [attr.r]="radius * 0.85"
          [attr.stroke-dasharray]="dashArray"
          [style.stroke-dashoffset]="progressInPixel + 'px'"
          fill="transparent"
          stroke-dashoffset="0"
          stroke-width="3"
        ></circle>
      </svg>
    }

    <ng-container [ngTemplateOutlet]="content"></ng-container>
  </button>
</ng-template>

<ng-template #content><ng-content></ng-content></ng-template>
